import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import useAuth from "../../hooks/useAuth";
import { isAccessRoute } from "../../auth/ProtectedRoutes";

const SidebarItem = (props) => {
  const { item, sidePath } = props;
  const [open, setOpen] = useState(
    sidePath.includes(item.route) ? true : false
  );

  // eslint-disable-next-line no-unused-vars
  const { auth } = useAuth();
  const isActive = (routes) => {
    // return routes === sidePath ? "active" : "";
    // return sidePath.includes(routes) ? "active" : "";

    if (sidePath.includes(routes)) {
      const nextChar = sidePath[routes.length];
      return nextChar === "/" || nextChar === undefined ? "active" : "";
    }

    return "";
  };

  const openSideBar = (routes) => {
    if (sidePath.includes(routes) && !open) {
      return false;
    }

    if (sidePath.includes(routes) || open) {
      return true;
    }
  };

  const handleOpenSideBar = (routes) => {
    setOpen(!open);
    // if (!sidePath.includes(routes)) {
    //   setOpen(true);
    // } else {
    //   setOpen(!open);
    // }
  };

  if (item?.children && item.children.length) {
    // * Nếu có chứa các route con thì lọc các route con thỏa điều kiện được phép truy xuất vào
    const listChildren = item.children.filter(
      (child) => auth?.id && isAccessRoute(auth?.permissions, child.permissions)
    );

    return (
      <div
        className={
          openSideBar(item.route) ? "sidebar__item open" : "sidebar__item"
        }
      >
        {/* <Link
          to={{
            pathname: listChildren[0]?.route,
            state: { permissions: listChildren[0]?.permissions },
          }}
        > */}
        <div
          onClick={() => handleOpenSideBar(item.route)}
          className={`sidebar__item-inner `}
          style={{ fontWeight: "bold" }}
        >
          <span>
            <i className={item.icon}></i>
            {item.name}
          </span>
          <i
            className="bx bxs-chevron-down toggle-btn"
            onClick={() => handleOpenSideBar(item.route)}
          ></i>
        </div>
        {/* </Link> */}

        <div className="sidebar-content">
          {listChildren.map((child, index) => (
            <SidebarItem key={index} item={child} sidePath={sidePath} />
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <Link
        to={{ pathname: item.route, state: { permissions: item.permissions } }}
      >
        <div className="sidebar__item">
          <div className={`sidebar__item-inner ${isActive(item.route)}`}>
            <span>
              <i className={item.icon}></i>
              {item.name}
            </span>
          </div>
        </div>
      </Link>
    );
  }
};

export default SidebarItem;
